import React from 'react';
import { Seo } from '../../components/Seo';
import { site } from '../../config/site';

export default function CookiesPolicyPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${site.name} — Politique cookies`,
    url: `${site.url}/politique-cookies`,
    inLanguage: 'fr-FR',
  };

  return (
    <>
      <Seo
        title="Politique cookies"
        description="Politique cookies LuckyBetFR: cookies essentiels, options d’audience, et comment gérer ton choix."
        canonicalPath="/politique-cookies"
        jsonLd={jsonLd}
      />

      <section className="lbf-container py-12 sm:py-16">
        <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl">Politique cookies</h1>
        <p className="mt-4 max-w-3xl text-sm text-zinc-200/85">
          LuckyBetFR utilise des cookies pour fonctionner correctement. Les cookies non essentiels restent optionnels et
          sont désactivés tant que tu ne les actives pas.
        </p>

        <div className="mt-10 grid gap-4">
          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Essentiels (obligatoires)</h2>
            <p className="mt-3 text-sm text-zinc-200/85">
              Utilisés pour la sécurité, l’affichage et la mémorisation de ton choix (ex: consentement).
            </p>
          </div>

          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Audience (optionnel)</h2>
            <p className="mt-3 text-sm text-zinc-200/85">
              Si tu l’actives, on peut mesurer l’usage du site pour améliorer les pages (ex: rendre une section plus
              rapide, clarifier un parcours).
            </p>
          </div>

          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Gérer ton choix</h2>
            <ul className="mt-4 grid gap-2 text-sm text-zinc-200/85">
              <li>- Via la bannière cookies au bas du site (au premier passage).</li>
              <li>- Via les paramètres de ton navigateur (effacer/autoriser).</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 text-xs text-zinc-400">
          Dernière mise à jour: 2025-12-17 • Domaine: <span className="font-semibold text-white/80">{site.domain}</span>
        </div>
      </section>
    </>
  );
}


